<template>
  <div class="my-3">
    <h4 class="mb-3">Activity log</h4>

    <b-table
      hover
      no-local-sorting
      no-sort-reset
      fixed
      stacked="lg"
      :items="mailLogs"
      :fields="fields"
      :sort-by="mailLogsSortBy"
      :sort-desc="mailLogsSortDirection === 'desc'"
      @sort-changed="sortChanged"
    >
      <template slot="created_at" slot-scope="data">
        <time :datetime="data.item.created_at">{{data.item.created_at|formatDate}}</time>
      </template>

      <template slot="contact" slot-scope="data">
        <a v-if="data.item.contact" :href="`${backendUrl}contacts/${data.item.contact_id}`" target="_blank">{{data.item.contact && data.item.contact.full_name}}</a>
      </template>

      <template slot="application" slot-scope="data">
        <a v-if="data.item.application" :href="`${backendUrl}applications/${data.item.application_id}`" target="_blank">{{data.item.application && data.item.application.full_address}}</a>
      </template>

      <template slot="campaign_stage" slot-scope="data">
        <router-link v-if="data.item.campaign_stage" :to="{ name: 'campaigns-edit-stages-edit', params: { id: data.item.campaign_id, stageid: data.item.campaign_stage_id } }">
          {{data.item.campaign_stage.name}}
        </router-link>
      </template>
    </b-table>

    <b-container>
      <b-row>
        <b-col>
          <b-alert show variant="info" v-if="mailLogs.length === 0">
            This campaign does not have any activity yet.
          </b-alert>
        </b-col>
      </b-row>
    </b-container>

    <nav-paginator
      :current-page="mailLogsPage"
      :total-pages="mailLogsTotalPages"
      :link-gen="linkGen"
    ></nav-paginator>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import store from '../store'
import moment from 'moment'
import NavPaginator from '@/components/NavPaginator'

function reloadPage(to, from, next) {
  let page = to.query.page || 1
  let sortBy = to.query.sort_by || 'created_at'
  let sortDesc = to.query.sort_direction ? to.query.sort_direction === 'desc' : true

  return store.dispatch('mail_logs/updateMailLogsSort', { sortBy, sortDesc })
    .then(() => {
      return Promise.all([
        store.dispatch('mail_logs/fetchAll', { id: to.params.id, page }),
        store.dispatch('campaigns/fetchOne', to.params.id)
      ])
    })
    .then(res => next())
}

export default {
  components: {
    NavPaginator
  },

  // handles initial page load
  beforeRouteEnter(to, from, next) {
    reloadPage(to, from, next)
  },

  // handles pagination and sorting
  beforeRouteUpdate(to, from, next) {
    reloadPage(to, from, next)
  },

  data() {
    return {
      pageTitle: 'Mail Logs',
      fields: [
        { key: 'created_at', label: 'Date', sortable: true, tdClass: ['text-nowrap'] },
        { key: 'contact', label: 'Contact', sortable: false, thClass: ['w-25'] },
        { key: 'application', label: 'Application', sortable: false, thClass: ['w-25'] },
        { key: 'campaign_stage', label: 'Stage', sortable: false, thClass: ['text-nowrap'] },
        { key: 'state', label: 'Status', sortable: true, tdClass: ['text-nowrap'] },
        { key: 'opens', label: 'Opens', sortable: true, tdClass: ['text-nowrap'] },
        { key: 'clicks', label: 'Clicks', sortable: true, tdClass: ['text-nowrap'] }
      ],
      backendUrl: process.env.VUE_APP_BACKEND_URL
    }
  },

  computed: {
    ...mapState('campaigns', [
      'campaign'
    ]),

    ...mapState('mail_logs', [
      'mailLogs',
      'mailLogsPage',
      'mailLogsTotalPages',
      'mailLogsSortBy',
      'mailLogsSortDirection'
    ])
  },

  filters: {
    formatDate(val) {
      return moment(val).format('MMM DD YYYY')
    }
  },

  methods: {
    ...mapActions('mail_logs', [
      'updateMailLogsSort'
    ]),

    linkGen(page) {
      // copy the original query string args and overwrite page
      return {
        query: {
          ...this.$route.query,
          page
        }
      }
    },

    sortChanged(ctx) {
      this.updateMailLogsSort(ctx)
        .then(() => {
          this.$router.push({
            name: this.$route.name,
            params: this.$route.params,
            query: {
              page: this.mailLogsPage,
              sort_by: this.mailLogsSortBy,
              sort_direction: this.mailLogsSortDirection
            }
          })
        })
        .catch(err => console.error(err))
    }
  }
}
</script>

<style scoped>

</style>
